import { render, staticRenderFns } from "./OverviewUpcoming.vue?vue&type=template&id=66df3265&scoped=true&"
import script from "./OverviewUpcoming.vue?vue&type=script&lang=js&"
export * from "./OverviewUpcoming.vue?vue&type=script&lang=js&"
import style0 from "./OverviewUpcoming.vue?vue&type=style&index=0&id=66df3265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df3265",
  null
  
)

export default component.exports